import React, { useState } from "react";
import api, { formatApiError } from "../../api";
import { label } from "../../labels";
import { btnPrimary, inputCls, panel } from "./ui";

const STATUSES = ["present", "absent", "late", "justified"];

export default function AttendanceAdmin({ studentId, attendance, onChange }) {
  const [form, setForm] = useState({ date: new Date().toISOString().slice(0, 10), status: "present", note: "" });
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/attendance", { ...form, studentId, note: form.note || null });
      setErr("");
      onChange();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  return (
    <div className="space-y-4">
      <form onSubmit={submit} className={`${panel} grid sm:grid-cols-4 gap-3`} data-testid="eid-att-form">
        <input type="date" required className={inputCls} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="eid-att-date" />
        <select className={inputCls} value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} data-testid="eid-att-status">
          {STATUSES.map((s) => <option key={s} value={s}>{label(s)}</option>)}
        </select>
        <input className={inputCls} placeholder="Nota (opcional)" maxLength={300} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="eid-att-note" />
        <button className={btnPrimary} data-testid="eid-att-submit">Registrar</button>
      </form>
      {err && <div className="text-[12px] text-[#9B2C3B]">{err}</div>}
      <p className="text-[11px] text-[#132C44]/55">Si ya existe un registro para esa fecha, se actualiza. La nota de asistencia es visible para el alumno y la familia.</p>
      <ul className="divide-y divide-[#132C44]/5 bg-white rounded-2xl border border-[#132C44]/10" data-testid="eid-att-list">
        {attendance.map((a) => (
          <li key={a.id} className="p-3 text-[13px] flex justify-between gap-2">
            <span>{a.date} · <strong>{label(a.status)}</strong></span>
            <span className="text-[#132C44]/60 truncate">{a.note}</span>
          </li>
        ))}
        {!attendance.length && <li className="p-3 text-[13px] text-[#132C44]/60">Sin registros.</li>}
      </ul>
    </div>
  );
}
